import React from 'react';
import './App.css';


import {
  Route,
  HashRouter,

} from "react-router-dom";
import { HomeForm } from './pages/home/HomeForm';
import { Page404 } from './pages/404/NotFound';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { Finish } from './pages/finish/Finish';
import { Utils } from './core/Utils';


export  let contextApp:any = {}
let color =  {
  main: "#2bb24b",
  light: "#bfe8c9",
  dark: "#1a9933",
}

export const outerTheme = createMuiTheme({
  palette: {
    primary: color
  },
});
function App() {

  if(Utils.isTelegram())
    color.main = "#1888cc"

 

  const initialState= {

    
    palette: {
      primary: color,
    }
  }
  const [state, dispatch] = React.useReducer(
    (prevState:any, action:any) => {
      switch (action.type) {
        case 'CHANGETHEME':
          document.body.style.backgroundColor = action.themeColor.body;
          document.head.insertAdjacentHTML("beforeend", `<style>
          .title-form{color:${action.themeColor.fontColor}}
          .countdown{color:${action.themeColor.fontColor}}
          
          </style>`)
        
      
  
          return {
            palette: {
              primary: {
                main: action.themeColor.fontColor,
                light: action.themeColor.fontColor,
                dark: action.themeColor.fontColor,
              },
            },
          };
       
       
      }
    },
    initialState
  );

  const authContext:any = React.useMemo(
    () => ({
      changeTheme: async (fontColor:string,bodyColor:string ) => {
    
        dispatch({ type: 'CHANGETHEME' ,themeColor: {body:bodyColor,fontColor:fontColor }});
      }
     
    }),
    []
  );

  contextApp = authContext;
 
  return (
    <React.StrictMode>
    <ThemeProvider theme={createMuiTheme(state)}>
        <HashRouter>
          <Route path='/form/:codeform' component={ HomeForm } exact />
          <Route path='/form-tl/:codeform' component={ HomeForm } exact />
          <Route path='/end/:codeform' component={ Finish } exact />
          <Route path='/404' component={ Page404 } exact />
        </HashRouter>
    </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
